module.exports = {
    NEW: 'NEW',
    VIEW: 'VIEW',
    EDIT: 'EDIT',
    DELETE: 'DELETE',
    GRID: 'GRID',
}